export enum AccountingInterfaceEnums {

    //Tipo Documento
    factura = 1,
    notaCredito = 2,
    notaDebito = 3,
    reciboCaja = 4,
    documentoSoporte = 5,
    notaAjusteDocumentoSoporte = 6,


}

export enum AccountingInterfaceStateEnums {
    //Estado Documento
    abierta = 1,
    cerrada = 2,
    impresa = 3,
    pagada = 4
}